module.exports = __webpack_public_path__ + "img/rotten_paprika_red.81150fb1.png";